<template>
  <div>
    <!-- Page Header -->
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t('edit_user') }}</h4>
        </div>
      </div>
      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link to="/users" class="btn btn-added">
              <span>{{ $t('back') }}</span>
            </router-link>
          </div>
        </li>
        <li>
          <a data-bs-toggle="tooltip" title="Collapse">
            <i class="ti ti-chevron-up"></i>
          </a>
        </li>
      </ul>
    </div>

    <!-- Form -->
    <form @submit.prevent="updateUser">
      <div class="card">
        <div class="card-body add-product pb-0">
          <div class="accordion-card-one accordion">
            <div class="accordion-item">
              <div class="accordion-collapse collapse show">
                <div class="accordion-body">
                  <div class="row">

                    <!-- Username -->
                    <div class="col-lg-6 mb-3">
                      <label class="form-label">
                        {{ $t('user_name') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model="form.username"
                        class="form-control"
                      />
                    </div>

                    <!-- Email -->
                    <div class="col-lg-6 mb-3">
                      <label class="form-label">
                        {{ $t('email') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model="form.email"
                        class="form-control"
                      />
                    </div>

                    <!-- Phone -->
                    <div class="col-lg-6 mb-3">
                      <label class="form-label">
                        {{ $t('phone_number') }}
                      </label>
                      <input
                        v-model="form.phone_number"
                        class="form-control"
                      />
                    </div>

                    <!-- Store -->
                    <div class="col-lg-6 mb-3">
                      <div class="d-flex align-items-center">
                        <label class="form-label me-3" style="width:200px;">
                          {{ $t('store_name') }}
                        </label>
                        <FormDropdown
                          v-model="form.store_id"
                          :options="formattedStores"
                          clearable
                        />
                      </div>
                    </div>

                    <!-- Role -->
                    <div class="col-lg-6 mb-3">
                      <div class="d-flex align-items-center">
                        <label class="form-label me-3" style="width:200px;">
                          {{ $t('role_name') }}
                        </label>
                        <FormDropdown
                          v-model="form.role_id"
                          :options="formattedRoles"
                          clearable
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="col-lg-12 text-end">
        <div class="btn-addproduct mb-4">
          <button type="button" class="btn btn-cancel me-2" @click="cancel">
            {{ $t('cancel') }}
          </button>
          <button type="submit" class="btn btn-submit">
            {{ $t('update') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import apiUrls from "@/urls";
import FormDropdown from "@/components/common/FormDropdown.vue";
import { useToast } from "vue-toastification";

export default {
  components: { FormDropdown },

  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      form: {
        username: "",
        email: "",
        phone_number: "",
        store_id: null,
        role_id: null,
      },
      stores: [],
      roles: [],
    };
  },

  async created() {
    const userId = this.$route.params.id;

    const res = await this.$axios.get(apiUrls.users.detail(userId));
    const u = res.data;

    this.stores = (await this.$axios.get(apiUrls.inventory_store.get)).data;
    this.roles = (await this.$axios.get(apiUrls.roles.get)).data;

    this.form = {
      username: u.username,
      email: u.email,
      phone_number: u.phone_number,
      store_id: u.assigned_store_id ?? null,
      role_id: u.assigned_role_id ?? null,
    };
  },

  computed: {
    formattedStores() {
      return this.stores.map(s => ({ id: s.id, text: s.name }));
    },
    formattedRoles() {
      return this.roles.map(r => ({ id: r.id, text: r.name }));
    },
  },

  methods: {
    async updateUser() {
      const userId = this.$route.params.id;
      try {
        await this.$axios.put(apiUrls.users.detail(userId), {
          ...this.form,
          store_id: this.form.store_id || null,
          role_id: this.form.role_id || null,
        });
        this.toast.success(this.$t("user_updated_successfully"));
        this.$router.push("/users");
      } catch (error) {
        const data = error.response?.data || {};
        const message = [data.error, data.detail, data.store_id, data.role_id, data.username, data.email]
          .flat()
          .find(Boolean);
        this.toast.error(message || this.$t("something_went_wrong"));
      }
    },

    cancel() {
      this.$router.push("/users");
    },
  },
};
</script>
